export const openGraphConstants = {
  description: 'description',
  img: 'default.png',
}
